import React from "react";
import { IPageIntroProps } from "./PageIntroProps";
import Row from "../../../components/global/Row/Row";
import {
  StyledContainer,
  Title,
  Title2,
  Title3,
  Description,
  TitleContainer,
  DescContainer,
} from "./PageIntroHelpers";
import Amenities from "../../../components/common/Amenities/Amenities";
import { useLocation } from "@reach/router";
import { usePageIntroSliceContext } from "../../../context/SliceContexts/PageIntroContext";

const PageIntro = (props: IPageIntroProps): JSX.Element => {
  const {
    parent_type,
    relationships,
    field_title,
    isbelowSearchParagraphs,
    field_link,
    field_description,
    children,
  } = usePageIntroSliceContext();

  const location = typeof window !== "undefined" ? window.location.href : "/";
  if (parent_type) {
    const amenities = relationships && relationships.field_amenities;
    const brand = relationships.brand;
    const color =
      brand && brand.length && brand[0].field_color
        ? brand[0].field_color.color
        : null;
    let primaryPage = false;
    if (
      location &&
      (location.indexOf("/our-brands") != -1 ||
        location.indexOf("/about") != -1 ||
        location.indexOf("/offers") != -1 ||
        location.indexOf("/support") != -1)
    ) {
      primaryPage = true;
    }

    return (
      <StyledContainer>
        <Row>
          <TitleContainer>
            {primaryPage ? (
              <Title2 id={`page-intro-title`}>{field_title}</Title2>
            ) : isbelowSearchParagraphs ? (
              <Title3 id={`page-intro-title`}>{field_title}</Title3>
            ) : (
              <Title id={`page-intro-title`}>{field_title}</Title>
            )}
          </TitleContainer>
          <DescContainer>
            <Description
              field_link={field_link}
              field_description={field_description}
            >
              {children}
            </Description>
            {amenities !== null && amenities.length > 0 && (
              <div className="amenitiesRow">
                {brand && brand.length && (
                  <h3 className="mt-4 mb-3">{`${brand[0].name} Amenities`}</h3>
                )}
                <Amenities amenities={amenities} color={color} />
              </div>
            )}
          </DescContainer>
        </Row>
      </StyledContainer>
    );
  }
  return <></>;
};

export default PageIntro;
